import { DEFAULT_LANGUAGE, DEFAULT_ZENDESK_LANGUAGE } from 'constants/localization';

import { isIOS, isAndroid } from 'helpers/devices';

export const getFaqLink = (value: string | null) => {
    const mobilePlatform = (isIOS && '8266653228061-iOS') || (isAndroid && '8250895372061-Android');

    const isDefaultLangNeededSet = !value || value === DEFAULT_LANGUAGE;

    const lang = isDefaultLangNeededSet ? DEFAULT_ZENDESK_LANGUAGE : value;

    if (mobilePlatform) {
        return `https://support.yoga-go.io/hc/${lang}/categories/${mobilePlatform}`;
    }

    return `https://support.yoga-go.io/hc/${lang}`;
};
